import React, { Component } from "react";

import Icon from "../../../../shared/items/static/icon";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import styles from "../cmsCompanies.module.scss";

class CmsDebtFilterTools extends Component {
  render() {
    const { debtMore, debtMonths, onChangeSearchTerm, onSelectDebt } = this.props;

    return (
      <div className={styles.container_direction}>
        <div style={{ display: "flex" }}>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 50, display: "inline-block" }} style={{ margin: "0px", padding: "3px" }}>
            <Select
              style={{ minWidth: "200px", margin: "0px" }}
              onChange={onSelectDebt}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={debtMonths}
            >
              <MenuItem value={0} className={styles.MuiButtonBase_resolve}>
                {"Без фильтра задолжености"}
              </MenuItem>
              <MenuItem value={1} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 1 месяца" : "меньше 1 месяца"
              }`}</MenuItem>
              <MenuItem value={2} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 2 месяцев" : "меньше 2 месяцев"
              }`}</MenuItem>
              <MenuItem value={3} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 3 месяцев" : "меньше 3 месяцев"
              }`}</MenuItem>
              <MenuItem value={4} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 4 месяцев" : "меньше 4 месяцев"
              }`}</MenuItem>
              <MenuItem value={5} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 5 месяцев" : "меньше 5 месяцев"
              }`}</MenuItem>
              <MenuItem value={6} className={styles.MuiButtonBase_resolve}>{`${
                debtMore ? "больше 6 месяцев" : "меньше 6 месяцев"
              }`}</MenuItem>
            </Select>
          </FormControl>
          <div>
            <div
              className={debtMore ? styles.container_direction_asc_active : styles.container_direction_asc}
              onClick={() => {
                if (!debtMore) onChangeSearchTerm("debtMore", !debtMore);
              }}
            >
              <Icon name="direction-asc" />
            </div>
            <div
              className={!debtMore ? styles.container_direction_desc_active : styles.container_direction_desc}
              onClick={() => {
                if (debtMore) onChangeSearchTerm("debtMore", !debtMore);
              }}
            >
              <Icon name="direction-desc" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CmsDebtFilterTools;
